import { IApiUserGroupParams, IJwtTokenWithApiKeyResponse } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { web3Api } from 'store/queries';

export interface IFetchRawJWTsParams extends IApiUserGroupParams {}

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchRawJWTs },
  useFetchRawJWTsQuery,
  useLazyFetchRawJWTsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchRawJWTs: build.query<
      IJwtTokenWithApiKeyResponse[],
      IFetchRawJWTsParams
    >({
      queryFn: createNotifyingQueryFn(async ({ group }) => {
        const api = MultiService.getService().getAccountingGateway();

        const jwts = await api.getAllJwtTokenWithApiKey({ group });

        return { data: jwts };
      }),
    }),
  }),
  overrideExisting: true,
});

const fetchRawJWTsFallback: IJwtTokenWithApiKeyResponse[] = [];

export const {
  selectDataWithFallbackCachedByParams: selectRawJWTs,
  selectLoadingCachedByParams: selectRawJWTsLoading,
  selectStateCachedByParams: selectRawJWTsState,
} = createQuerySelectors({
  endpoint: fetchRawJWTs,
  fallback: fetchRawJWTsFallback,
});
